<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body p-0">
        <kendo-datasource ref="datasource1"
            :transport-read="getProduct"
            :schema="schema()"
            :schema-model-id="'uid'"
            :batch='true'
            :page-size='limit'
            :page="page"
            :server-paging='true'
            :server-sorting='true'
            :server-filtering='true'
            :sort="{ field: 'name', dir: 'asc' }">
        </kendo-datasource>
        <kendo-grid ref="gridComponent" :data-source-ref="'datasource1'"
            :filterable='true'
            :pageable="{ pageSizes: [10, 15, 25, 50], buttonCount: 3, input: true }"
            :sortable='true'
            :resizable='true'
            detail-template="#= detail(uid, active, code, name.value, principal.value, prices.value, meta, description, stock.value, unit) # # setTimeout(function () { console.log(kendo); var chartEl = kendo.initWidget($('\#chart-' + uid), chartOptions(code), kendo.dataviz.ui); }, 500) #">
          <kendo-grid-column field="parent" title="Parent" template="#= parentProduct.template(parentProduct.value) #" :filterable="getProductFilters()"></kendo-grid-column>
          <kendo-grid-column field="code" title="Code" :filterable="getProductFilters()"></kendo-grid-column>
          <kendo-grid-column field="name" title="Name" :filterable="getProductFilters()" template="#= name.template #"></kendo-grid-column>
          <kendo-grid-column field="principal" title="Latest Principal" 
            template="<span class='d-block'>#: kendo.toString(parseFloat(principal.value), 'c') #</span>"
            :filterable="false"></kendo-grid-column>
          <kendo-grid-column field="prices" title="Retail Prices"
            template="#= prices.template(prices.value) #" :sortable="false" :filterable="false"></kendo-grid-column>
          <kendo-grid-column field="stock" title="Stock" template="#= stock.template(stock.value, unit.toLowerCase()) #"
            :sortable="false" :filterable="false" width="100px"></kendo-grid-column>
          <kendo-grid-column v-if="account.role === 'FINANCE' || account.role === 'WAREHOUSE' || account.role === 'MANAGER'"
            title="&nbsp;" template="#= getCommand(code) #" width="100px"></kendo-grid-column>
        </kendo-grid>
      </div>
      <div class="card-footer text-right">
        
        <div class="btn-group">
            <a href="/#/product/print" target="_blank" class="d-block btn btn-primary" style="padding-top: 15px;">Print Product</a>
            <button type="button" class="btn btn-lg btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" @click="exportProduct">
                <span class="d-inline-block">
                  &nbsp;Export Product Data
                </span>
              </button>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      button: {
        name: 'Add Product',
        icon: 'fa fa-box',
        url: '/product/add'
      },
      limit: 15,
      page: 1,
      priceType: {},
      account: JSON.parse(localStorage.getItem('account'))
    }
  },
  created () {
    // set culture
    window.kendo.culture('id-ID')
    // change button
    // this.$parent.button = this.button
    // do something here
    this.getSalesType()
  },
  methods: {
    getSalesType () {
      var vm = this
      vm.axios('api/inventory/outbound/type/')
        .then(
          (response) => {
            vm.priceType = response.data
          }
        )
    },
    schema () {
      var vm = this
      return {
        total: 'count',
        data: 'results',
        parse: function (response) {
          console.log(response)
          for (var i = 0; i < response.results.length; i++) {
            var name = {
              value: response.results[i].name,
              template: '<span class=\'d-block text-capitalize\'>' + response.results[i].name.toLowerCase() + '</span>'
            }
            var principal = {
              value: response.results[i].principal,
              template: function (price) {
                if (price > 0) {
                  return '<span class="d-inline-block">IDR</span><span class="d-inline-block float-right">' +
                    (price / 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '</span>'
                } else {
                  return '<span class="d-inline-block">IDR</span><span class="d-inline-block float-right">-</span>'
                }
              }
            }
            var prices = {
              value: response.results[i].prices,
              template: function (price) {
                if (!price) {
                  price = {
                    'RETAIL': 0
                  }
                }
                return '<span class="d-inline-block">' + window.kendo.toString(price['RETAIL'], 'c') + '</span>'
              }
            }
            var stock = {
              value: response.results[i].stock,
              template: function (value, unit) {
                return '<span class="d-inline-block" style="min-width: 50px">' + window.kendo.toString(value, 'n0') + '</span><span class="d-inline-block">' + unit + '</span>'
              }
            }
            var parentProduct = {
              value: response.results[i].parent,
              template: function (parent) {
                if (parent) {
                  return '<span class="text-capitalize">' + parent.parent_name.toLowerCase() + '</span>'
                } else {
                  return ''
                }
              }
            }
            response.results[i].name = name
            response.results[i].principal = principal
            response.results[i].prices = prices
            response.results[i].stock = stock
            response.results[i].parentProduct = parentProduct
            response.results[i].stockMovement = function (code) {
              return {
                transport: {
                  read: function (event) {
                    var currentDate = moment()
                    var monthsBefore = moment().subtract(60, 'days')
                    vm.axios.get('api/report/stock/movement/?product=' + code + '&date=' +
                                        encodeURIComponent(monthsBefore.format('DD-MM-YYYY') + ';' + currentDate.format('DD-MM-YYYY')))
                      .then(
                        (response) => {
                          console.log(response)
                          event.success(response)
                        }
                      )
                  }
                },
                schema: { data: 'data' }
              }
            }
            response.results[i].getCommand = function (code) {
              var account = JSON.parse(localStorage.getItem('account'))
              var command = ''
              if (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER') {
                command += '<a class="btn btn-outline-warning d-block" href="/#/product/edit/' + code + '">Edit</a>'
              }
              return command
            }
            response.results[i].detail = function (uid, active, code, name, principal, prices, meta, description, stock, unit) {
              var detail = '<div class="row m-0"><div class="col-12 p-0"><span class="d-block " style="margin-bottom: 20px;">'
              var status = '<i class="material-icons text-success">power_settings_new</i>' +
                            '<span class="d-inline-block" style="margin-top: -15px; vertical-align: middle">&nbsp;Product Active</span>'
              if (!active) {
                status = '<i class="material-icons text-secondary">power_settings_new</i>' +
                          '<span class="d-inline-block" style="margin-top: -15px; vertical-align: middle">&nbsp;Product Inactive</span>'
              }
              detail += status
              detail += '</span></div>'
              detail += '<div class="col-6 col-md-3 p-0">Product Code</div>'
              detail += '<div class="col-6 col-md-3 p-0 font-weight-bold text-uppercase">' + code + '</div>'
              detail += '<div class="col-6 col-md-3 p-0">Product Name</div>'
              detail += '<div class="col-6 col-md-3 p-0 font-weight-bold text-capitalize">' + name.toLowerCase() + '</div>'

              var metaStr = '-'
              if (meta) {
                metaStr = meta.join(', ')
              }
              detail += '<div class="col-6 col-md-3 p-0">Product Tag</div>'
              detail += '<div class="col-6 col-md-3 p-0 font-weight-bold text-capitalize">' + metaStr.toLowerCase() + '</div>'

              var desc = '-'
              if (description) {
                desc = description
              }
              detail += '<div class="col-6 col-md-3 p-0">Product Description</div>'
              detail += '<div class="col-6 col-md-3 p-0 font-weight-bold text-capitalize">' + desc.toLowerCase() + '</div>'

              detail += '<hr class="col-12"/>'
              var priceList = {}
              if (prices) {
                priceList = prices
              }
              for (var i = 0; i < vm.priceType.length; i++) {
                detail += '<div class="col-6 col-md-3 p-0 text-capitalize">' + vm.priceType[i].name.toLowerCase() + '</div>'
                var priceStr = '-'
                var margin = 0
                var marginClass = ''
                if (vm.priceType[i].name in priceList) {
                  var price = priceList[vm.priceType[i].name]
                  priceStr = window.kendo.toString(Number(price), 'c')
                  if (Number(principal) > 0) {
                    margin = (Number(price) - Number(principal)) / Number(principal)
                    if (margin > 0) {
                      marginClass = '<i class="fa fa-arrow-up text-success"></i>&nbsp;'
                    } else {
                      marginClass = '<i class="fa fa-arrow-down text-danger"></i>&nbsp;'
                    }
                  }
                }
                detail += '<div class="col-6 col-md-3 p-0 font-weight-bold text-capitalize"><span class="d-inline-block">' + priceStr +
                          '</span><span class="float-right d-inline-block" style="margin-right: 15px">' + marginClass + window.kendo.toString(margin, 'p1') + '</span></div>'
              }

              detail += '<hr class="col-12"/>'
              detail += '<div class="col-6 col-md-3 p-0">Stock</div>'
              detail += '<div class="col-6 col-md-3 p-0 font-weight-bold text-uppercase">' + stock + ' ' + unit + '</div>'
              detail += '</div>'
              // chart
              detail += '<div class="row" style="margin-right: 0px">'
              detail += '<div id="chart-' + uid + '" class="col-12 p-0" style="height: 200px" data-role="chart"></div>'
              detail += '</div>'

              return detail
            }
            response.results[i].chartOptions = function (code) {
              return {
                theme: 'material',
                chartArea: {
                  background: 'transparent'
                },
                title: {
                  text: 'Stock Movement (Last 60 Days)',
                  align: 'left'
                },
                dataSource: {
                  transport: {
                    read: function (event) {
                      var currentDate = moment()
                      var monthsBefore = moment().subtract(60, 'days')
                      vm.axios.get('api/report/stock/movement/?product=' + code + '&date=' +
                                          encodeURIComponent(monthsBefore.format('DD-MM-YYYY') + ';' + currentDate.format('DD-MM-YYYY')))
                        .then(
                          (response) => {
                            event.success(response)
                          }
                        )
                    }
                  },
                  schema: {
                    data: 'data',
                    parse: function (response) {
                      var data = response.data
                      var today = moment()
                      var found = false
                      for (var i = 0; i < data.length; i++) {
                        // formating date
                        var datePart = data[i].dates.split('-')
                        var year = parseInt(datePart[0])
                        var month = parseInt(datePart[1]) - 1
                        var date = parseInt(datePart[2])
                        response.data[i].date = new Date(year, month, date)
                        // check if it is today's data
                        if (response.data[i].dates === today.format('YYYY-MM-DD')) {
                          found = true
                        }
                      }
                      if (!found) {
                        var todayData = {
                          inbound: 0,
                          outbound: 0,
                          dates: today.format('YYYY-MM-DD'),
                          date: new Date(parseInt(today.format('YYYY')), parseInt(today.format('MM')) - 1, parseInt(today.format('DD')))
                        }
                        response.data.push(todayData)
                      }
                      return response
                    }
                  }
                },
                seriesDefaults: { type: 'column' },
                series: [
                  {
                    field: 'inbound',
                    categoryField: 'date',
                    name: 'IN',
                    labels: {
                      visible: true,
                      visual: function (e) {
                        if (parseInt(e.text) > 0) {
                          return e.createVisual()
                        }
                      }
                    }
                  },
                  {
                    field: 'outbound',
                    categoryField: 'date',
                    name: 'OUT',
                    labels: {
                      visible: true,
                      font: '12px Roboto !important',
                      visual: function (e) {
                        if (parseInt(e.text) > 0) {
                          return e.createVisual()
                        }
                      }
                    }
                  }
                ],
                legend: {
                  position: 'bottom'
                },
                valueAxis: {
                  labels: {
                    color: 'transparent',
                    border: {
                      color: 'transparent',
                      width: 0
                    }
                  },
                  line: {
                    color: 'transparent',
                    width: 0
                  },
                  majorGridLines: {
                    width: 0,
                    color: 'transparent'
                  },
                  minorGridLines: {
                    width: 0,
                    color: 'transparent'
                  }
                },
                categoryAxis: {
                  color: '#848484',
                  labels: {
                    font: '10px Roboto !important',
                    dateFormats: {
                      days: 'dd'
                    }
                  },
                  baseUnit: 'days',
                  line: {
                    color: '#000'
                  },
                  majorGridLines: {
                    width: 0,
                    color: 'transparent'
                  },
                  minorGridLines: {
                    width: 0,
                    color: 'transparent'
                  }
                }
              }
            }
          }
          return response
        }
      }
    },
    getProduct (event) {
      var vm = this
      var limit = event.data.take
      var offset = event.data.skip

      var baseUri = 'api/sales/products/?limit=' + limit + '&offset=' + offset
      var sort = ''
      if (event.data.sort && event.data.sort.length > 0) {
        var temp = event.data.sort[0]
        sort = temp.field + '-' + temp.dir
      }
      if (sort.length > 0) {
        baseUri += '&sort=' + sort
      }
      var filters = []
      if (event.data.filter) {
        filters = event.data.filter.filters
      }
      for (var i = 0; i < filters.length; i++) {
        var tempFilter = filters[i]
        baseUri += '&' + tempFilter.field + '=' + encodeURIComponent(tempFilter.value + ';' + tempFilter.operator)
      }
      vm.axios.get(baseUri)
        .then(
          (response) => {
            event.success(response.data)
          }
        )
    },
    getProductFilters () {
      // var vm = this
      return {
        extra: false,
        operators: {
          string: { contains: 'contains', eq: 'exact' }
        }
      }
    },
    editProduct (event) {
      event.preventDefault()
      var tr = (event.target).closest('tr')
      var code = tr.children[1].innerHTML
      this.$router.push('/product/edit/' + code)
    },
    exportProduct () {
      var vm = this
      vm.axios.get('api/sales/products/export/', { responseType: 'arraybuffer' })
        .then(
          (response) => {
            var blob = new Blob([response.data], { type: response.headers['content-type'] })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Product List ' + moment().format('YYYYMMDD') + '.xls'
            link.click()
          }
        )
        .catch(
          (error) => {
            console.log(error.response)
            console.log(error)
            vm.$parent.showNotification('Oops! Unable to submit data at this moment. Please try again later!', 'danger')
          }
        )
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/Product.vue